/**
 * Partnership Badge Component
 * Displays partnership badges for organizations like HEART Trust
 */

import React from 'react';
import { Chip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';

const PartnershipBadge = ({ type = 'verified', size = 'medium', sx = {} }) => {
  const badgeConfig = {
    government: {
      label: 'Gov Partner',
      color: '#009639',
      textColor: 'white',
      icon: <VerifiedIcon sx={{ fontSize: '16px' }} />
    },
    verified: {
      label: 'Verified',
      color: '#2196F3',
      textColor: 'white',
      icon: <VerifiedIcon sx={{ fontSize: '16px' }} />
    }
  };
  
  const config = badgeConfig[type] || badgeConfig.verified;
  
  return (
    <Chip
      icon={config.icon}
      label={config.label}
      size={size}
      className="partnership-badge"
      sx={{
        backgroundColor: config.color,
        color: config.textColor,
        fontWeight: 'bold',
        fontSize: size === 'small' ? '0.7rem' : '0.75rem',
        height: size === 'small' ? 20 : 24,
        '& .MuiChip-icon': {
          color: config.textColor
        },
        '& .MuiChip-label': {
          paddingLeft: 0.5,
          paddingRight: 0.5
        },
        transition: 'all var(--motion-duration, 0.2s) ease',
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
        },
        ...sx
      }}
    />
  );
};

export default PartnershipBadge;